import {
  Archive,
  ArchiveRestore,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  BadgeCheck,
  Boxes,
  Braces,
  Check,
  ChevronDown,
  CircuitBoard,
  CircleAlert,
  CircleHelp,
  Clock3,
  Copy,
  Component as ComponentIcon,
  Database,
  Download,
  EllipsisVertical,
  Eye,
  FileText,
  FolderKanban,
  FolderOpen,
  Image,
  Laptop,
  List,
  Grid2X2,
  LayoutTemplate,
  LoaderCircle,
  Maximize2,
  Menu,
  Minimize2,
  Minus,
  Monitor,
  Palette,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRight,
  PanelRightClose,
  PanelRightOpen,
  Pencil,
  PencilLine,
  Plus,
  Plug,
  Puzzle,
  Redo2,
  RefreshCw,
  Rocket,
  Route,
  Search,
  Settings,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  Table2,
  Tags,
  Trash2,
  Undo2,
  Upload,
  Users,
  Workflow,
  X,
  ZoomIn,
  type LucideIcon,
} from 'lucide-react';

export const studioIconRegistry = Object.freeze({
  'action.add': Plus,
  'action.archive': Archive,
  'action.back': ArrowLeft,
  'action.cancel': X,
  'action.confirm': Check,
  'action.delete': Trash2,
  'action.download': Download,
  'action.duplicate': Copy,
  'action.import': Upload,
  'action.next': ArrowRight,
  'action.more': EllipsisVertical,
  'action.open': FolderOpen,
  'action.refresh': RefreshCw,
  'action.rename': PencilLine,
  'action.restore': ArchiveRestore,
  'action.sort': ArrowUpDown,
  'navigation.chevron-down': ChevronDown,
  'status.error': CircleAlert,
  'status.loading': LoaderCircle,
  'studio.help': CircleHelp,
  'studio.brand': CircuitBoard,
  'studio.inspector': PanelRight,
  'studio.menu': Menu,
  'studio.settings': Settings,
  'studio.theme': Palette,
  'studio.sidebar.collapse': PanelLeftClose,
  'studio.sidebar.expand': PanelLeftOpen,
  'studio.panel.collapseLeft': PanelLeftClose,
  'studio.panel.expandLeft': PanelLeftOpen,
  'studio.panel.collapseRight': PanelRightClose,
  'studio.panel.expandRight': PanelRightOpen,
  'studio.sidebar.editor': Pencil,
  'studio.sidebar.screens': Monitor,
  'studio.sidebar.components': Boxes,
  'studio.sidebar.templates': LayoutTemplate,
  'studio.sidebar.aiGenerate': Sparkles,
  'studio.sidebar.records': Database,
  'studio.sidebar.models': Table2,
  'studio.sidebar.dataSources': Plug,
  'studio.sidebar.queries': Search,
  'studio.sidebar.workflows': Workflow,
  'studio.sidebar.state': Braces,
  'studio.sidebar.forms': FileText,
  'studio.sidebar.navigation': Route,
  'studio.sidebar.users': Users,
  'studio.sidebar.admin': ShieldCheck,
  'studio.sidebar.media': Image,
  'studio.sidebar.extensions': Puzzle,
  'studio.sidebar.themes': Palette,
  'studio.sidebar.designSystem': ComponentIcon,
  'studio.sidebar.tokens': Tags,
  'studio.sidebar.preview': Eye,
  'studio.sidebar.compatibility': BadgeCheck,
  'studio.sidebar.export': Download,
  'studio.sidebar.deploy': Rocket,
  'studio.topbar.tools': SlidersHorizontal,
  'studio.topbar.document': FileText,
  'studio.topbar.platform': Monitor,
  'studio.topbar.breakpoint': Laptop,
  'studio.topbar.undo': Undo2,
  'studio.topbar.redo': Redo2,
  'studio.topbar.zoom': ZoomIn,
  'studio.view.grid': Grid2X2,
  'studio.view.list': List,
  'studio.projects': FolderKanban,
  'studio.history': Clock3,
  'studio.mobile.components': Boxes,
  'studio.mobile.screens': Monitor,
  'studio.mobile.canvas': Pencil,
  'studio.mobile.properties': PanelRight,
  'studio.mobile.more': Menu,
  'studio.mobile.outline': LayoutTemplate,
  'window.close': X,
  'window.minimize': Minus,
  'window.maximize': Maximize2,
  'window.restore': Minimize2,
} satisfies Record<string, LucideIcon>);

export type StudioIconId = keyof typeof studioIconRegistry;

export function getStudioIcon(iconId: StudioIconId): LucideIcon {
  return studioIconRegistry[iconId];
}
